export function pathFromActivatedRoute(route) {
  return '/' + route.pathFromRoot.map(r => r.snapshot.url).filter(f => !!f[0]).map(([f]) => f.path).join('/');
}